import { resolveMerchStoreApiUrl } from './merchstore';

const GET_MEMBER_CART_SUMMARY = resolveMerchStoreApiUrl(
  '/.netlify/functions/merchstore-api/fetchMemberCartSummary'
);

export { GET_MEMBER_CART_SUMMARY };
